export default __webpack_public_path__ + "img/e097b1a37136e9c9e1e5a80469508f82.jpg";